import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Universities from "./pages/Universities";
import ApplicationProcess from "./pages/ApplicationProcess";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import Dormitories from "./pages/Dormitories";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hizmetler" element={<Services />} />
          <Route path="/universiteler" element={<Universities />} />
          <Route path="/yurtlar" element={<Dormitories />} />
          <Route path="/basvuru-sureci" element={<ApplicationProcess />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/iletisim" element={<Contact />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
